import store from '@/store'
import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'


export type SearchSmallCategoriesCondition = {
  customerId?: number;
  largeCategoryCd?: number;
  middleCategoryCd?: number;
  lengths?: string[];
  diameters?: string[];
}

export function useSearchSmallCategoriesFunc() {

  const getWhere = (condition: SearchSmallCategoriesCondition) => {
    // 得意先で絞る --------------------
    let customerId = condition.customerId
    if (!customerId) {
      // ログイン中の得意先CDで絞り込む
      customerId = store.getters['loginUser/customer']?.id
    }

    const where: api.SmallCategoryWhereInput  = {
      AND: [
        {
          items: {
            some: {
              stockItems: {
                some: {
                  stockItemUnitPrices: {
                    some: {
                      customerId: {
                        equals: customerId
                      }
                    }
                  }
                }
              }
            }
          }
        }
      ],
    }

    // 大分類で絞る --------------------
    // let largeCategoryId = condition.largeCategoryId
    // if (!!largeCategoryId) {
    //   where.AND?.push({
    //     items: {
    //       some: {
    //         largeCategory: {
    //           is: {
    //             id: { equals: largeCategoryId }
    //           }
    //         }
    //       }
    //     }
    //   })
    // }
    let largeCategoryCd = condition.largeCategoryCd
    if (!!largeCategoryCd) {
      where.AND?.push({
        items: {
          some: {
            largeCategory: {
              is: {
                largeCd: { equals: largeCategoryCd }
              }
            }
          }
        }
      })
    }

    // 中分類で絞る --------------------
    // let middleCategoryId = condition.middleCategoryId
    // if (!!middleCategoryId) {
    //   where.AND?.push({
    //     items: {
    //       some: {
    //         middleCategory: {
    //           is: {
    //             id: { equals: middleCategoryId }
    //           }
    //         }
    //       }
    //     }
    //   })
    // }
    let middleCategoryCd = condition.middleCategoryCd
    if (!!middleCategoryCd) {
      where.AND?.push({
        items: {
          some: {
            middleCategory: {
              is: {
                middleCd: { equals: middleCategoryCd }
              }
            }
          }
        }
      })
    }

    // 径で絞る --------------------
    let diameters = condition.diameters
    if (!!diameters && diameters.length > 0) {
      where.AND?.push({
        items: {
          some: {
            stockItems: {
              some: {
                diameter: { in: diameters }
              }
            }
          }
        }
      })
    }
    

    // 長さで絞る --------------------
    let lengths = condition.lengths
    if (!!lengths && lengths.length > 0) {
      where.AND?.push({
        items: {
          some: {
            stockItems: {
              some: {
                length: { in: lengths }
              }
            }
          }
        }
      })
    }

    return where
  }

  const {
    load: searchSmallCategoriesLoad,
    refetch: searchSmallCategoriesRefetch,
    onResult: searchSmallCategoriesOnResult,
    onError: searchSmallCategoriesOnError
  } = useLazyQuery<
    api.SmallCategoriesQuery,
    api.SmallCategoriesQueryVariables
  >(api.SmallCategoriesDocument, undefined)

  const searchSmallCategoriesFetchOrRefetch = (variables:api.SmallCategoriesQueryVariables) => {
    searchSmallCategoriesLoad(api.SmallCategoriesDocument, variables) || searchSmallCategoriesRefetch(variables)
  }

  const searchSmallCategories = ( condition: SearchSmallCategoriesCondition ) => {
    const where = getWhere(condition)

    // 検索実行
    searchSmallCategoriesFetchOrRefetch({
      where,
      orderBy: [
        {
          smallCd: {
            sort: api.SortOrder.Asc
          }
        }
      ]
    })
  }

  return {
    searchSmallCategories,
    searchSmallCategoriesOnResult,
    searchSmallCategoriesOnError
  }
}
